import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type { GTMEventGlycerinLinkClick } from '@packages/tracking/src/types/events';
import { dispatchDisplayOverlayTracking } from '@packages/shared/src/ui/Dialog/dispatchDialogOverlayTracking';
import { useLayerTracking } from '../../../Tracking/hooks/useLayerTracking/useLayerTracking';

const defaultLabel = 'APlus Service';

export const useAPlusTracking = () => {
  const dispatchTracking = useTracking();
  const { trackViewServiceLayer } = useLayerTracking();

  const trackInfoButtonClick = ({ uuid, name }: { uuid: string; name: string | null }) => {
    dispatchTracking<GTMEventGlycerinLinkClick>({
      event: 'LinkClick',
      LinkClickData: {
        category: uuid,
        detail: name || undefined,
        label: defaultLabel,
      },
    });
    trackViewServiceLayer(name);
    dispatchDisplayOverlayTracking({
      eventDispatcher: dispatchTracking,
      displayTrackingProps: { category: uuid, detail: name || undefined, label: defaultLabel },
    });
  };

  return { trackInfoButtonClick };
};
